import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "source",
    "manualFields",
    "stripeFields",
    "mode",
    "recordedOn",
    "submit"
  ]

  connect() {
    this.toggle()
  }

  toggle() {
    const source = this.sourceTarget.value
    const stripeSource = source === "stripe"

    this.manualFieldsTargets.forEach((element) => {
      element.classList.toggle("d-none", stripeSource)
      element.querySelectorAll("input, select, textarea").forEach((field) => {
        if (field.type === "hidden") return
        field.disabled = stripeSource
      })
    })

    if (this.hasStripeFieldsTarget) {
      this.stripeFieldsTargets.forEach((element) => {
        element.classList.toggle("d-none", !stripeSource)
        element.querySelectorAll("input, select, textarea").forEach((field) => {
          field.disabled = !stripeSource
        })
      })
    }

    if (this.hasModeTarget) {
      this.modeTarget.required = !stripeSource
    }

    if (this.hasRecordedOnTarget) {
      this.recordedOnTarget.required = !stripeSource
    }

    if (this.hasSubmitTarget) {
      const labels = {
        stripe: this.submitTarget.dataset.stripeLabel,
      }

      this.submitTarget.value = labels[source] || this.submitTarget.dataset.manualLabel
    }
  }

  prepareSubmit(event) {
    const source = this.sourceTarget.value
    if (source !== "stripe") return

    const refundFormController = this.application.getControllerForElementAndIdentifier(
      this.element,
      "ledger-refund-form"
    )

    if (refundFormController) {
      refundFormController.prepareSubmit(event)
    }
  }
}
